import { render, staticRenderFns } from "./order-status-displays.vue?vue&type=template&id=b392f98e"
import script from "./order-status-displays.vue?vue&type=script&lang=js"
export * from "./order-status-displays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports